import { useEffect, useRef, useState } from 'react';

const useBarkodOkuyucu = (timeoutMs = 100, isInputFocused = false, setInputValue = null) => {
    const [barkodDegeri, setBarkodDegeri] = useState('');
    const [barkodGecmisi, setBarkodGecmisi] = useState([]);
    const barkodBufferRef = useRef('');
    const barkodTimeoutRef = useRef(null);
    const isProcessingRef = useRef(false);

    useEffect(() => {
        const handleKeyPress = (event) => {
            // Eğer barkod işleniyorsa veya input focus ise yeni barkod okutmayı engelle
            if (isProcessingRef.current || isInputFocused) {
                return;
            }

            // Barkod okuyucu genellikle Enter tuşu ile biter
            if (event.key === 'Enter') {
                if (barkodBufferRef.current.trim()) {
                    const yeniBarkod = barkodBufferRef.current.trim();
                    isProcessingRef.current = true;
                    setBarkodDegeri(yeniBarkod);

                    // Input alanında barkodu göster
                    if (setInputValue) {
                        setInputValue(yeniBarkod);
                    }

                    setBarkodGecmisi(prev => [...prev, {
                        barkod: yeniBarkod,
                        tarih: new Date().toLocaleString('tr-TR')
                    }]);
                    barkodBufferRef.current = '';

                    // Barkod işlendikten sonra processing flag'ini temizle
                    setTimeout(() => {
                        isProcessingRef.current = false;
                    }, 200);
                }
            } else if (event.key.length === 1) {
                // Sadece karakter tuşlarını al
                barkodBufferRef.current += event.key;

                // Barkod okuyucu genellikle hızlı okur, bu yüzden timeout kullanıyoruz
                if (barkodTimeoutRef.current) {
                    clearTimeout(barkodTimeoutRef.current);
                }
                barkodTimeoutRef.current = setTimeout(() => {
                    if (barkodBufferRef.current.trim() && !isProcessingRef.current) {
                        const yeniBarkod = barkodBufferRef.current.trim();
                        isProcessingRef.current = true;
                        setBarkodDegeri(yeniBarkod);

                        // Input alanında barkodu göster
                        if (setInputValue) {
                            setInputValue(yeniBarkod);
                        }

                        setBarkodGecmisi(prev => [...prev, {
                            barkod: yeniBarkod,
                            tarih: new Date().toLocaleString('tr-TR')
                        }]);
                        barkodBufferRef.current = '';

                        // Barkod işlendikten sonra processing flag'ini temizle
                        setTimeout(() => {
                            isProcessingRef.current = false;
                        }, 200);
                    }
                }, timeoutMs);
            }
        };

        // Global event listener ekle - sadece input focus değilse
        if (!isInputFocused) {
            document.addEventListener('keypress', handleKeyPress);
        }

        // Component unmount olduğunda event listener'ı temizle
        return () => {
            document.removeEventListener('keypress', handleKeyPress);
            if (barkodTimeoutRef.current) {
                clearTimeout(barkodTimeoutRef.current);
            }
        };
    }, [timeoutMs, isInputFocused, setInputValue]); // setInputValue dependency'sini ekledim

    const temizleGecmis = () => {
        setBarkodGecmisi([]);
        setBarkodDegeri('');
        barkodBufferRef.current = '';
        isProcessingRef.current = false;
        if (barkodTimeoutRef.current) {
            clearTimeout(barkodTimeoutRef.current);
        }
    };

    const temizleBarkodDegeri = () => {
        setBarkodDegeri('');
        barkodBufferRef.current = '';
        isProcessingRef.current = false;
        if (barkodTimeoutRef.current) {
            clearTimeout(barkodTimeoutRef.current);
        }
    };

    const barkodEkle = async (barkod) => {
        if (barkod && barkod.trim()) {
            const yeniBarkod = barkod.trim();
            isProcessingRef.current = true;
            await setBarkodDegeri(yeniBarkod);
            await setBarkodGecmisi(prev => [...prev, {
                barkod: yeniBarkod,
                tarih: new Date().toLocaleString('tr-TR')
            }]);

            // Barkod işlendikten sonra processing flag'ini temizle
            setTimeout(() => {
                isProcessingRef.current = false;
            }, 200);
        }
    };

    return {
        barkodDegeri,
        barkodGecmisi,
        temizleGecmis,
        temizleBarkodDegeri,
        barkodEkle
    };
};

export default useBarkodOkuyucu; 